<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
button.disabled {
  cursor: no-drop;
}
td button.btn.status {
  cursor: auto;
}
</style>
<template>
  <div>
    <div class="row ml-2 mb-3">
      <div class="form-group">
        <label for class="h5">Detail Peserta RPL</label>
      </div>
    </div>
    <CCard>
      <!-- Tabs -->
      <div class="card-header bg-primary font-weight-bold text-white d-flex align-items-center">
        Sertifikasi
        <Button
          class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
          @click="$router.go(-1)"
        >Kembali</Button>
      </div>
      <div>
        <CCardBody class="mt-3">
          <CRow>
            <CCol lg="12" class="table-responsive">
              <CDataTable
                style="widht:100% !important"
                :items="items"
                :fields="fields"
                table-filter
                hover
                sorter
                pagination
              >
                <template #no="{index}">
                  <td class="py-2">{{ index += 1 }}</td>
                </template>
                <template #nama_tc="{item}">
                  <td class="py-2" v-if="item.status_tc == '1'">{{ item.nama_tc }}</td>
                  <td class="py-2" v-else>{{ item.lokasi }}</td>
                </template>
                <template #sesi="{item}">
                  <td class="py-2" v-if="item.status_tc == '1'">{{ item.sesi }}</td>
                  <td class="py-2" v-else>1</td>
                </template>
                <template #nilai="{item}">
                  <td class="py-2" v-if="item.status_tc == '1'">{{ item.nilai }}</td>
                  <td class="py-2" v-else>*Lokasi di Workshop</td>
                </template>
                <template #status_pembayaran="{item}">
                  <td
                    class="py-2 text-success text-center font-weight-bold"
                    v-if="item.status_pembayaran == 'settlement'"
                  >Lunas</td>
                  <td
                    class="py-2 text-purple text-center font-weight-bold"
                    v-else-if="item.status_pembayaran == 'pending'"
                  >Menunggu Pembayaran</td>
                  <td
                    class="py-2 text-secondary text-center font-weight-bold"
                    v-else-if="item.status_pembayaran == 'expired'"
                  >Expired</td>
                  <td
                    class="py-2 text-secondary text-center font-weight-bold"
                    v-else-if="item.status_pembayaran == 'failure'"
                  >Pembayaran Gagal</td>
                  <td
                    class="py-2 text-danger text-center font-weight-bold"
                    v-else-if="item.status_pembayaran == 0"
                  >Belum Dibayar</td>
                  <td
                    class="py-2 text-danger text-center font-weight-bold"
                    v-else
                  >Belum Lunas</td>
                </template>
                <template #_status="{item}">
                  <td class="py-2">
                    <i class="fa fa-check text-success" aria-hidden="true" v-if="item._status == 1"></i>
                    <font-awesome-icon icon="times" class="text-danger" v-else />
                  </td>
                </template>
                
              </CDataTable>
            </CCol>
          </CRow>
        </CCardBody>
      </div>
    </CCard>
    <!-- Modal Detail User -->
    <CModal
      title="Modal title"
      :show.sync="myModal"
      :no-close-on-backdrop="true"
      :centered="true"
      size="lg"
    >
      <CRow class="px-3">
        <table class="table table-bordered font-weight-bold">
          <tr>
            <th class="bg-primary" style="width: 40%">Nama Mata Uji</th>
            <td>{{ formData.nama_mata_uji }}</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Tanggal Pendaftaran</th>
            <td>{{ formData.created_at }}</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Sesi</th>
            <td class="font-weight-bold">{{ formData.sesi }}</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Nilai</th>
            <td class="font-weight-bold">{{ formData.nilai }}</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Status Dokumen</th>
            <td class="text-success">Terverifikasi</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Status Pembayaran</th>
            <td class="" v-if="formData.status_pembayaran == 0">Belum Melakukan Pembayaran</td>
            <td class="text-success" v-else>{{ formData.status_pembayaran }}</td>
          </tr>
        </table>
      </CRow>
      <template #header>
        <h6 class="modal-title h4 font-weight-bold">Detail</h6>
      </template>
      <template #footer>
        <CButton @click="myModal = false" color="danger">Tutup</CButton>
      </template>
    </CModal>
    <!-- End Modal -->
    <!-- End Data Sertifikasi -->
  </div>
</template>
<script>
import DataPesertaRplService from "../../../../services/sertifikasi/data-peserta-rpl.service";
import { AlertUtils } from "../../../../mixins/AlertUtils";
import { Pagination } from "../../../../mixins/Pagination";
const items = [
  {
    no: "1",
    mataUji: "Mata Uji 1",
    tglDaftar: "20-02-2020",
    namaTc: "UIN"
  },
  {
    no: "2",
    mataUji: "Mata Uji 2",
    tglDaftar: "20-02-2020",
    namaTc: "UIN"
  },
  {
    no: "3",
    mataUji: "Mata Uji 3",
    tglDaftar: "20-02-2020",
    namaTc: "UIN"
  },
  {
    no: "4",
    mataUji: "Mata Uji 4",
    tglDaftar: "20-02-2020",
    namaTc: "UIN"
  },
  {
    no: "5",
    mataUji: "Mata Uji 5",
    tglDaftar: "20-02-2020",
    namaTc: "UIN"
  }
];

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: "nama_mata_uji",
    label: "Mata Uji",
    sorter: true,
    filter: false
  },
  {
    key: "nama_tc",
    label: "Nama Test Center",
    sorter: true,
    filter: false
  },
  {
    key: "created_at",
    label: "Tanggal Daftar",
    sorter: true,
    filter: false
  },
  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: true,
    filter: false
  },
  {
    key: "sesi",
    label: "Sesi",
    sorter: true,
    filter: false
  },
  {
    key: "nilai",
    label: "Nilai Akhir",
    sorter: true,
    filter: false
  },
  
];

export default {
  mixins : [
    AlertUtils
  ],
  data() {
    return {
      items: [],
      actionPost: "",
      formData: {
        id_mata_uji_peserta : '',
        id_sertifikasi_rpl_peserta : '',
        id_invoice : '',
        kehadiran : '',
        status_kelulusan : '',
        status_mata_uji : '',
        status_pembatalan : '',
        status_refund : '',
        created_at : '',
        nilai : '',
        status_pembayaran : '',
        nama_mata_uji : '',
        nama_tc : '',
        alamat : '',
        nama_kota_kab : '',
        sesi : '',
      },
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  mounted() {
    this.getData(0,10,this.filter,this.$route.params.id_sertifikasi_rpl_peserta);
  },
  methods: {
    lihatDetail(item)
    {
      this.myModal = true;
      this.formData.id_mata_uji_peserta = item.id_mata_uji_peserta;
      this.formData.id_sertifikasi_rpl_peserta = item.id_sertifikasi_rpl_peserta;
      this.formData.id_invoice = item.id_invoice;
      this.formData.kehadiran = item.kehadiran;
      this.formData.status_kelulusan = item.status_kelulusan;
      this.formData.status_mata_uji = item.status_mata_uji;
      this.formData.status_pembatalan = item.status_pembatalan;
      this.formData.status_refund = item.status_refund;
      this.formData.created_at = item.created_at;
      this.formData.nilai = item.nilai;
      this.formData.status_pembayaran = item.status_pembayaran;
      this.formData.nama_mata_uji = item.nama_mata_uji;
      this.formData.nama_tc = item.nama_tc;
      this.formData.alamat = item.alamat;
      this.formData.nama_kota_kab = item.nama_kota_kab;
      this.formData.sesi = item.sesi;
    },
    getData(currentPage,pageSize,filter,idSertifikasiPeserta)
    {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      DataPesertaRplService.getMataUjiPesertaSertifikasi(currentPage,pageSize,filter,idSertifikasiPeserta)
      .then(response => {
          vm.items = response.data.data.content;
          loader.hide();  
      }).catch(error => {
        // comment console console.log(error);
      })
    }
  }
};
</script>